var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"timer-to-update py-0"},[(this.showTimer() && _vm.showCountDown)?_c('p',{staticClass:"mb-0"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }